import axios from 'axios';
import qs from 'qs';

// 配置
const Service = axios.create({
  withCredentials: true,
  timeout: 60000,
  headers: {
    'x-requested-with': 'XMLHttpRequest',
    post: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
    },
  },
});

// 添加请求拦截器
Service.interceptors.request.use((config) => { // eslint-disable-line
  // 在发送请求之前做某事
  return config;
}, (error) => { // eslint-disable-line
  // 请求错误时做些事
  return Promise.reject(error);
});

// 添加响应拦截器
Service.interceptors.response.use((response) => { // eslint-disable-line
  // 对响应数据做些事
  if (response.status === 200) {
    return response.data;
  }
  return null;
}, (error) => { // eslint-disable-line
  // 请求错误时做些事
  return Promise.reject(error);
});

export default Service;

/**
 * 登录
 * @param {String} host
 * @param {Object} data
 * @param {Function} onSuccess
 * @param {Function} onError
 */
export function apiLogin(host, data, onSuccess, onError) {
  Service.post(`${host}/validate?redirect_uri=${encodeURIComponent(window.location.href)}`, qs.stringify(data)).then((res) => {
    if (!res) {
      if (onError && typeof onError === 'function') {
        onError();
      }
      return;
    }
    if (res.success) {
      if (onSuccess && typeof onSuccess === 'function') {
        onSuccess(res);
      } else {
        window.location.reload();
      }
    } else if (res.errorCode === 2
      || res.errorCode === 12 || res.errorCode === 13) { // 判断是否需要图片验证码
      if (onError && typeof onError === 'function') {
        onError(res, true);
      }
    } else if (onError && typeof onError === 'function') {
      onError(res);
    }
  }).catch((err) => {
    console.error(err); // eslint-disable-line
    if (onError && typeof onError === 'function') {
      onError(err);
    }
  });
}

/**
 * 是否需要验证码
 * @param {String} host
 * @param {Function} callback
 */
export function apiNeedCaptcha(host, callback) {
  Service.post(`${host}/isNeedImgCaptcha`).then((res) => {
    let isNeed = false;
    if (res.success && res.result) {
      isNeed = true;
    }
    if (callback && typeof callback === 'function') {
      callback(isNeed);
    }
  });
}

/**
 * 获取验证码
 * @param {String} host
 * @param {Object} data
 */
export function apiCode(host, type, mobile, mobileImgCaptcha, onSuccess, onError) {
  let url = `${host}/captcha/mobile/${type}/${mobile}`;
  const msg = '获取验证码失败！';
  if (mobileImgCaptcha) {
    url += `?moblieImgCaptcha=${mobileImgCaptcha}`;
  }
  Service.get(url).then((res) => {
    if (res && res.success) {
      if (onSuccess && typeof onSuccess === 'function') {
        onSuccess();
      }
    } else if (onError && typeof onError === 'function') {
      onError(res && res.errorMessage ? res.errorMessage : msg);
    }
  }).catch((err) => {
    console.error(err); // eslint-disable-line
    if (onError && typeof onError === 'function') {
      onError(msg);
    }
  });
}

/**
 * 校验手机验证码
 * @param {String} host
 * @param {Object} data
 */
export function apiVerifyCode(host, mobile, code, onSuccess, onError) {
  const url = `${host}/reg/captcha/verify`;
  const msg = '网络异常，注册失败';
  Service.post(url, { mobile, code }).then((res) => {
    if (res && res.success) {
      if (onSuccess && typeof onSuccess === 'function') {
        onSuccess();
      }
    } else if (onError && typeof onError === 'function') {
      onError(res && res.errorMessage ? res.errorMessage : msg);
    }
  }).catch((err) => {
    console.error(err); // eslint-disable-line
    if (onError && typeof onError === 'function') {
      onError(msg);
    }
  });
}

/**
 * 用户注册
 * @param {String} host
 * @param {Object} data
 */
export function apiRegUser(host, data, onSuccess, onError) {
  Service.post(`${host}/reg/user`, qs.stringify(data)).then((res) => {
    if (res && res.success) {
      if (onSuccess && typeof onSuccess === 'function') {
        onSuccess(res);
      } else {
        window.location.reload();
      }
    } else if (onError && typeof onError === 'function') {
      onError(res);
    }
  }).catch((err) => {
    console.error(err); // eslint-disable-line
    if (onError && typeof onError === 'function') {
      onError(err);
    }
  });
}

/**
 * 登录器广告封面
 * @param {String} host
 * @param {String} posterId - denglu_001/zhuce_001
 */
export function apiPoster(host, posterId, onSuccess, onError) {
  const advCode = posterId || 'denglu_001';
  Service.get(`${host}/ucenter/common/getAdlistByCode?advCode=${advCode}`).then((res) => {
    if (res && res.success && res.result) {
      const list = res.result || [];
      if (list.length && onSuccess && typeof onSuccess === 'function') {
        onSuccess(list[0].advDetailContent);
      } else if (onError && typeof onError === 'function') {
        onError();
      }
    } else if (onError && typeof onError === 'function') {
      onError();
    }
  }).catch((err) => {
    console.error(err); // eslint-disable-line
    if (onError && typeof onError === 'function') {
      onError();
    }
  });
}

/**
 * 是否显示角色弹窗
 * @param {String} host
 */
export function apiShowRoles(host, onSuccess, onError) {
  Service.post(`${host}/home/isShowRolesSet`).then((res) => {
    if (res.success) {
      if (onSuccess && typeof onSuccess === 'function') {
        onSuccess(res.result);
      }
    } else if (onError && typeof onError === 'function') {
      onError();
    }
  }).catch((err) => {
    console.error(err); // eslint-disable-line
    if (onError && typeof onError === 'function') {
      onError();
    }
  });
}

/**
 * 设置用户角色
 * @param {String} host
 * @param {String} roleId
 * @param {Function} onSuccess
 * @param {Function} onError
 */
export function apiSetRole(host, roleId, onSuccess, onError) {
  Service.post(`${host}/home/creatUserSetRole`, { id: roleId }).then((res) => {
    if (res.success && res.result) {
      if (onSuccess && typeof onSuccess === 'function') {
        onSuccess(res);
      }
    } else if (onError && typeof onError === 'function') {
      onError(res);
    }
  }).catch((err) => {
    console.error(err); // eslint-disable-line
    if (onError && typeof onError === 'function') {
      onError(err);
    }
  });
}

/**
 * 查手机号对应多账号数据
 * @param {String} host
 * @param {String} mobile
 * @param {Function} onSuccess
 * @param {Function} onError
 */
export function apiUserInfoByMobile(host, mobile, loginType, onSuccess, onError) {
  Service.get(`${host}/user/queryUserInfoByMobile?mobile=${mobile}&loginType=${loginType}`).then((res) => {
    if (res.success && res.result) {
      if (onSuccess && typeof onSuccess === 'function') {
        onSuccess(res.result);
      }
    } else if (onError && typeof onError === 'function') {
      onError();
    }
  }).catch((err) => {
    console.error(err); // eslint-disable-line
    if (onError && typeof onError === 'function') {
      onError();
    }
  });
}

/**
 * 查账号/手机号是否需要勾选协议
 * @param {String} host
 * @param {String} account
 * @param {Function} onSuccess
 * @param {Function} onError
 */
export function apiAgreement(host, account, onSuccess, onError) {
  Service.post(`${host}/isAgreement/${account}`).then((data) => {
    if (data === 1) {
      if (onError && typeof onError === 'function') {
        onError(data);
      }
    } else if (onSuccess && typeof onSuccess === 'function') {
      onSuccess(data); // 需要选择协议
    }
  }).catch((err) => {
    console.error(err); // eslint-disable-line
    if (onError && typeof onError === 'function') {
      onError();
    }
  });
}

/**
 * 注册获取验证码超过3次时出现图形验证码
 * @param {String} host
 * @param {Function} callback
 */
export function apiIsShowCaptcha(host, callback) {
  Service.post(`${host}/captcha/isNeedMobileImgCaptcha`).then((res) => {
    let isNeed = false;
    if (res.success && res.result) {
      isNeed = true;
    }
    if (callback && typeof callback === 'function') {
      callback(isNeed);
    }
  });
}

/**
 * 注册获取验证码超过3次时出现图形验证码
 * @param {String} host
 * @param {Function} callback
 */
export function apiGetRigesterRecommend(host, onSuccess, onError) {
  Service.post(`${host}/common/getRigesterRecommend`).then((res) => {
    if (res && res.success && res.result) {
      const list = res.result;
      if (list && onSuccess && typeof onSuccess === 'function') {
        onSuccess(list);
      } else if (onError && typeof onError === 'function') {
        onError();
      }
    } else if (onError && typeof onError === 'function') {
      onError();
    }
  }).catch((err) => {
    console.error(err); // eslint-disable-line
    if (onError && typeof onError === 'function') {
      onError();
    }
  });
}
